<template>
  <div class="year-month-selector-section">
    <button class="year-month-selector-section__selector" @click="handleSelectorClicked">
      <span>{{ selectedYearOrMonth.value }}</span>
      <span class="year-month-selector-section__selector-icon">
        <calendar-chevron-down-icon />
      </span>
    </button>
    <div class="year-month-selector-section__menu" v-if="state.menuVisible">
      <ul class="year-month-selector-section__menu-list">
        <li
          v-for="item in [...calendarYearList, ...calendarYearAndMonthList]"
          :key="item.value"
          class="year-month-selector-section__menu-item"
        >
          <button
            class="year-month-selector-section__option"
            :class="{
              'year-month-selector-section__option--selected':
                selectedYearOrMonth.value === item.value,
            }"
            @click="handleYearsAndMonthsClicked(item)"
          >
            <span>{{ item.value }}</span>
          </button>
        </li>
      </ul>
    </div>
    <div
      class="year-month-selector-section__overlay"
      v-if="state.menuVisible"
      @click="handleOverlayClicked"
    ></div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, reactive } from '@vue/composition-api'
import CalendarChevronDownIcon from '@/components/LinkPage/CalendarPane/parts/icons/CalendarChevronDownIcon.vue'
import { CalendarDateSelectType } from '@/components/LinkPage/hooks/useCalendarSelectList'

export default defineComponent({
  name: 'CalendarYearMonthSelectorSection',
  components: { CalendarChevronDownIcon },
  props: {
    /**
     * モータースポーツカレンダー画面で選択できる年/年月のプルダウン（年）
     */
    calendarYearList: {
      type: Array as PropType<CalendarDateSelectType[]>,
      default: () => [],
    },
    /**
     * モータースポーツカレンダー画面で選択できる年/年月のプルダウン（年.月）
     */
    calendarYearAndMonthList: {
      type: Array as PropType<CalendarDateSelectType[]>,
      default: () => [],
    },
    /**
     * モータースポーツカレンダー画面で選択できる年/年月のプルダウン（年.月）
     */
    selectedYearOrMonth: {
      type: Object as PropType<CalendarDateSelectType>,
      default: () => ({}),
    },
  },
  setup(_props, { emit }) {
    const state = reactive({
      menuVisible: false,
    })

    const handleSelectorClicked = () => {
      state.menuVisible = !state.menuVisible
    }

    /**
     * 年（年月）が変更された場合の処理
     */
    const handleYearsAndMonthsClicked = (yearsAndMonths: CalendarDateSelectType) => {
      state.menuVisible = false
      emit('onYearsAndMonthsSelect', yearsAndMonths)
    }
    const handleOverlayClicked = () => {
      state.menuVisible = false
    }
    return {
      state,
      handleSelectorClicked,
      handleYearsAndMonthsClicked,
      handleOverlayClicked,
    }
  },
})
</script>

<style scoped lang="scss">
.year-month-selector-section {
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  background-color: #f7f7f7;

  &__selector {
    display: flex;
    gap: 4px;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: $black;

    &-icon {
      width: 18px;
      height: 18px;
    }
  }

  &__menu {
    position: fixed;
    top: 19px;
    left: 50%;
    z-index: 2;
    min-width: 100px;
    max-height: calc(100% - 38px - 48px);
    overflow-y: auto;
    background-color: $white;
    border: 1px solid $gray10;
    border-radius: 4px;
    transform: translateX(-50%);

    &-item {
      + .year-month-selector-section__menu-item {
        position: relative;

        &::before {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          content: '';
          border-top: 1px solid $black10;
        }
      }
    }
  }

  &__option {
    width: 100%;
    padding: 8px 8px 8px 12px;
    font-size: 14px;
    font-weight: 600;
    color: $gray75;
    white-space: nowrap;

    &--selected {
      color: $black;
      background-color: $green;
    }
  }

  &__overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }
}
</style>
